import { useHomePageStore } from "@/store";
import { useAuthStore } from "@/store/auth.store";
import { ThumbaIcon } from "@roman/shared/components/Icons";
import { AvatarIcon } from "@roman/shared/components/Icons/AvatarIcon";
import { ThumbaBetaIcon } from "@roman/shared/components/Icons/ThumbaBetaIcon";
import { cn } from "@roman/shared/utils";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginButton } from "./LoginButton";
import { PointsButton } from "./PointsButton";
import { RedeemablePointsHeader } from "./RedeemablePointsHeader";
import { RegisterButton } from "./RegisterButton";
import { TopMenu } from "./TopMenu";
import { TopPageRegisterButton } from "./TopPageRegisterButton";

export const Header = () => {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const setIsOpenMyPageSidebar = useHomePageStore((state) => state.setIsOpenMyPageSidebar);

  const { authState } = useAuthStore();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isEditProfile = location.pathname === "/edit-profile";
  const isTopPage = location.pathname === "/top";
  const isLoginPage = location.pathname === "/login";
  const isRegisterPage = location.pathname === "/register";
  const isCenteredLayout = isTopPage || isLoginPage || isRegisterPage;

  return (
    <>
      <TopMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      <div className="sticky top-0 z-[50] w-full">
        <header
          className={cn(
            "h-[72px] bg-white drop-shadow-[0_35px_35px_rgba(0,0,0,0.05)] flex",
            isCenteredLayout && "justify-center",
          )}
        >
          {!isCenteredLayout && <div className="md:w-1/4"> </div>}
          <div
            className={cn(
              "flex justify-between items-center px-4",
              isCenteredLayout ? "w-full max-w-[770px] md:px-0" : "xl:w-2/4 w-full md:w-3/4",
            )}
          >
            {isMenuOpen ? (
              <div className="w-full mx-auto">
                <div className="flex items-center gap-6">
                  <img
                    src="/assets/close-icon.svg"
                    alt="Close Menu"
                    className="h-10 cursor-pointer"
                    onClick={() => setIsMenuOpen(false)}
                  />
                  {/* <TopPageRegisterButton
                    onClick={() => {
                      navigate("/register");
                      setIsMenuOpen(false);
                    }}
                    className="w-[320px] bg-primary text-white font-semibold px-6 py-2 rounded-full"
                  /> */}
                </div>
              </div>
            ) : (
              <>
                {isTopPage ? (
                  <>
                    {/* mobile */}
                    <div className="flex md:hidden justify-center items-center h-full">
                      <img
                        src="/assets/top-menu-icon.png"
                        alt="Top Menu"
                        className="h-10 flex-shrink-0"
                        onClick={() => setIsMenuOpen(true)}
                      />
                      <ThumbaIcon className="text-primary h-10 flex-shrink-0" onClick={() => navigate("/")} />
                    </div>
                    {/* PC */}
                    <div
                      className="hidden md:flex flex-col items-center justify-center cursor-pointer"
                      onClick={() => navigate("/")}
                    >
                      <p className="text-primary text-[10px] font-bold">未来予想で、ちょい稼げる！</p>
                      <img src="/assets/logo.svg" alt="logo" className="h-10" />
                    </div>
                  </>
                ) : (
                  <>
                    {/* mobile */}
                    <div className="flex md:hidden justify-center items-center h-full">
                      <ThumbaBetaIcon
                        className="text-primary h-12 w-12"
                        onClick={() => {
                          window.location.href = "/";
                        }}
                      />
                    </div>
                    {/* PC */}
                    <div
                      className="hidden md:flex flex-col items-center justify-center cursor-pointer"
                      onClick={() => {
                        window.location.href = "/";
                      }}
                    >
                      <p className="text-primary text-[10px] font-bold">未来予想で、ちょい稼げる！</p>
                      <img src="/assets/logo-beta.svg" alt="logo" className="h-10" onClick={() => navigate("/")} />
                    </div>
                  </>
                )}
                {isTopPage && authState === "unauthenticated" && (
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-4">
                      <a href="https://x.com/ThumbaJP">
                        <img src="/assets/icon-x-primary.svg" alt="logo" />
                      </a>
                    </div>
                    <TopPageRegisterButton
                      onClick={() => {
                        navigate("/register");
                        setIsMenuOpen(false);
                      }}
                      className="w-[132px] bg-primary text-white font-semibold px-6 py-2 rounded-full"
                    />
                  </div>
                )}

                {authState === "unauthenticated" && !isTopPage && (
                  <div className="flex items-center gap-4">
                    <LoginButton />
                    <RegisterButton />
                  </div>
                )}

                {authState === "authenticated" ? (
                  isEditProfile ? (
                    <div className="flex items-center gap-4">
                      <LoginButton />
                      <RegisterButton />
                    </div>
                  ) : (
                    <div
                      className={cn(
                        "flex items-center",
                        user &&
                          isTopPage &&
                          (Number(user.redeemablePoints) >= 10000000 || Number(user.freePoints) >= 10000000)
                          ? "gap-1 md:gap-4"
                          : "gap-3 md:gap-4",
                      )}
                    >
                      {user && <RedeemablePointsHeader user={user} />}
                      {user && <PointsButton user={user} onClick={() => navigate("/redeem-points")} />}
                      {user && (
                        <div
                          className={cn(
                            "flex justify-center items-center rounded-full bg-secondary cursor-pointer",
                            isTopPage &&
                              (Number(user.redeemablePoints) >= 10000000 || Number(user.freePoints) >= 10000000)
                              ? "h-[35px] w-[35px] md:h-[40px] md:w-[40px]"
                              : "h-[40px] w-[40px] md:h-[40px] md:w-[40px]",
                          )}
                          onClick={() => setIsOpenMyPageSidebar(true)}
                        >
                          {user?.photoUrl ? (
                            <img
                              src={user.photoUrl}
                              alt={user.name.substring(0, 1)}
                              className="rounded-full"
                              referrerPolicy="no-referrer"
                            />
                          ) : (
                            <AvatarIcon className="text-secondary" />
                          )}
                        </div>
                      )}
                    </div>
                  )
                ) : null}
              </>
            )}
          </div>
          {!isCenteredLayout && <div className="xl:w-1/4"> </div>}
        </header>
      </div>
    </>
  );
};
